import Axios from 'axios';
import { getAuthApiBase } from './authBase';
import { getIdpApiBase } from './idpBase';

export const signInUserWithEmailPasswordRequest = ({ username, password }) => {
    return Axios({
        method: 'post',
        url: window.ApiURL + 'authorization/v1/auth/authentication/user/create',
        data: {
            deviceUniqueId: 'Portal',
            username: username,
            password: password
        },
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

export const firstLoginCheck = ({ authToken, deviceId, merchantId }) => {
    if (authToken != null && merchantId != null) {
        return Axios({
            method: 'get',
            url: getIdpApiBase() + 'v2/merchant/' + merchantId + '/first-login',
            headers: {
                authToken: authToken,
                deviceUniqueId: deviceId,
            },
        });
    }
};

function resolveForgotEmail({ email, username }) {
    return email != null && email !== '' ? email : username;
}

/** Public — request password reset e-mail (auth-service). */
export const forgotPasswordApi = ({ email, username }) => {
    return Axios({
        method: 'post',
        url: getAuthApiBase() + 'v2/user/password/forgot',
        data: {
            email: resolveForgotEmail({ email, username }),
        },
        headers: {
            'Content-Type': 'application/json',
        },
    });
};

/** Public — complete reset from e-mail link (auth-service). */
export const resetPasswordApi = ({ userId, merchantId, code, password }) => {
    return Axios({
        method: 'post',
        url: getAuthApiBase() + 'v2/user/password/reset',
        data: {
            userId,
            merchantId,
            code,
            password,
        },
        headers: {
            'Content-Type': 'application/json',
        },
    });
};

export const changePasswordApi = ({ authToken, deviceId, currentPassword, password }) => {
    return Axios({
        method: 'post',
        url: getAuthApiBase() + 'v2/user/password/change',
        data: {
            passwordOld: currentPassword,
            password: password,
        },
        headers: {
            'Content-Type': 'application/json',
            'authToken': authToken,
            'deviceUniqueId': deviceId,
        }
    });
};

export const logoutUserApi = () => {
    return Axios({
        method: 'post',
        url: window.ApiURL + 'authorization/v2/user/logout',
        data: {},
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'authToken': localStorage.getItem('a'),
            'deviceUniqueId': 'Portal',
        }
    });
};
